/* ==========================================================================
   VAVYA wishlist — self-contained.

   Unsen's own wishlist bindings sit behind this guard in interactable.min.js:

       ((!isStorageSpdLocalAll && h) || v) || ( ...all the click bindings... )

   If that first half is truthy the theme never binds ANY click handler, so a
   click on the heart just follows its href and lands on the product page.
   That is what was happening.

   This file does the job itself. It reads and writes the SAME localStorage
   key in the SAME format the theme uses ("t4s_wis" = "id:123,id:456"), so the
   header counter, the header wishlist link and the wishlist page all keep
   working exactly as before — whether or not the theme's own JS ever runs.

   The card markup uses [data-vy-wish] instead of [data-action-wishlist] so
   the theme's handler and this one can never both fire on the same click.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__vyWish) return;
  window.__vyWish = true;

  var KEY   = 't4s_wis';        // canonical id list, the theme's own format
  var HKEY  = 'vy_wis_h';       // id -> handle, so the page can be rebuilt without search
  var ADDED = 'is--added';
  var MAX   = 50;               // same cap the theme uses

  /* ---------- storage ---------- */

  function read() {
    try {
      var v = localStorage.getItem(KEY);
      if (!v) return [];
      return v.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, list.join(',')); } catch (e) {}
  }

  function readMap() {
    try { return JSON.parse(localStorage.getItem(HKEY) || '{}') || {}; } catch (e) { return {}; }
  }

  function writeMap(m) {
    try { localStorage.setItem(HKEY, JSON.stringify(m)); } catch (e) {}
  }

  // every heart on the page knows its own handle - keep the map topped up
  function learnHandles() {
    var m = readMap(), dirty = false;
    each('[data-vy-wish],[data-vy-wish-remove]', function (el) {
      var id = el.getAttribute('data-id');
      var h  = el.getAttribute('data-handle');
      if (id && h && m[id] !== h) { m[id] = h; dirty = true; }
    });
    if (dirty) writeMap(m);
  }

  /* ---------- the wishlist page URL, built the theme's way ---------- */

  function searchUrl() {
    return (window.vyWishSearchUrl || '/search').replace(/\/$/, '');
  }

  // Handles, not ids. main-wishlist.liquid looks each one up with all_products
  // and renders the same card snippet the Tabs Collection uses, so the two
  // grids match exactly. Falls back to the theme's id: form if a handle is
  // missing for everything saved.
  function pageUrl(list) {
    if (!list.length) return searchUrl() + '?view=wishlist';

    var map = readMap();
    var handles = list
      .map(function (k) { return map[k.replace('id:', '')]; })
      .filter(Boolean);

    if (handles.length) {
      return searchUrl() + '?view=wishlist&type=product&q=' + encodeURIComponent(handles.join(' '));
    }
    return searchUrl() +
           '?view=wishlist&type=product&options[unavailable_products]=last&q=' +
           encodeURI(list.join(' OR '));
  }

  /* ---------- reflect state into the page ---------- */

  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
  }

  function sync() {
    var list = read();
    var url  = pageUrl(list);

    each('[data-count-wishlist]', function (el) {
      el.textContent = list.length;
      el.classList[list.length ? 'remove' : 'add']('t4s-op-0');
    });

    each('[data-link-wishlist]', function (a) { a.setAttribute('href', url); });

    each('[data-vy-wish]', function (el) {
      var id = el.getAttribute('data-id');
      var on = id && list.indexOf('id:' + id) > -1;
      el.classList[on ? 'add' : 'remove'](ADDED);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // keep the theme's own helpers in the loop when they did manage to load
    try {
      if (window.T4SThemeSP) {
        window.T4SThemeSP.linkWishlist = url;
        if (window.jQuery_T4NT) window.jQuery_T4NT(document).trigger('update:mini_cart:wishlist');
      }
    } catch (e) {}
  }

  /* ---------- actions ---------- */

  function toggle(el) {
    var id = el.getAttribute('data-id');
    if (!id) return;
    var list = read();
    var i = list.indexOf('id:' + id);
    if (i > -1) {
      list.splice(i, 1);
    } else {
      list.unshift('id:' + id);
      var h = el.getAttribute('data-handle');
      if (h) { var m = readMap(); m[id] = h; writeMap(m); }
    }
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
    sync();
  }

  function remove(el) {
    var id = el.getAttribute('data-id');
    var list = read();
    var i = id ? list.indexOf('id:' + id) : -1;
    if (i > -1) { list.splice(i, 1); write(list); }
    var card = el.closest ? el.closest('.vy-card') : null;
    if (card && card.parentNode) card.parentNode.removeChild(card);
    sync();
  }

  /* ---------- one delegated listener ---------- */

  function onClick(ev) {
    if (ev.__vyHandled) return;          // capture already dealt with it
    var t = ev.target;
    if (!t || !t.closest) return;

    var add = t.closest('[data-vy-wish]');
    if (add) { ev.__vyHandled = true; ev.preventDefault(); toggle(add); return; }

    var rm = t.closest('[data-vy-wish-remove]');
    if (rm) { ev.__vyHandled = true; ev.preventDefault(); remove(rm); }
  }

  // Capture runs before anything else on the page, so a carousel, an app or the
  // theme cannot swallow the click first. Bubble is the backstop if some parent
  // stops propagation before it reaches document. The flag stops both firing.
  document.addEventListener('click', onClick, true);
  document.addEventListener('click', onClick, false);

  /* ---------- wishlist page: build it from handles, not from search ----------
     Shopify's `q=id:...` search was returning nothing, so instead we ask the
     Section Rendering API for one card per saved handle. Cards land inside the
     wishlist section, so they inherit its CSS variables and match the site. */

  function buildPage() {
    var grid = document.querySelector('[data-vy-wish-grid]');
    if (!grid) return;                       // not the wishlist page

    // the server already rendered products - leave it alone
    if (grid.querySelector('.vy-card')) return;
    if (document.querySelector('.t4s-products-wishlist .vy-card, .t4s-products-wishlist .t4s-product')) return;

    var list = read();
    if (!list.length) return;                // genuinely empty, show the message

    var map = readMap();
    var handles = list
      .map(function (k) { return map[k.replace('id:', '')]; })
      .filter(Boolean);

    if (!handles.length) return;

    // We know cards are coming, so hide the "empty" message NOW rather than
    // letting it flash on screen for the length of the fetch.
    var empty = document.querySelector('[data-vy-wish-empty]');
    if (empty) empty.setAttribute('hidden', '');

    var root = (window.vyWishSearchUrl || '/search').replace(/\/search\/?$/, '') || '';

    Promise.all(handles.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '?section_id=vavya-wish-item')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.map(function (p) {
        if (!p) return '';
        var d = document.createElement('div');
        d.innerHTML = p;
        var item = d.querySelector('[data-vy-item]');
        return item ? item.innerHTML : '';
      }).join('');

      if (!html.trim()) {
        if (empty) empty.removeAttribute('hidden');   // nothing came back after all
        return;
      }

      grid.innerHTML = html;
      grid.removeAttribute('hidden');
      sync();
      try { if (window.lazySizesT4) window.lazySizesT4.autoSizer.checkElems(); } catch (e) {}
    });
  }

  /* ---------- run ---------- */

  function init() { learnHandles(); sync(); buildPage(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () { setTimeout(function () { learnHandles(); sync(); }, 300); });

  /* Theme editor: changing any setting makes Shopify re-render the section.
     The replacement HTML is built from the section URL, which in the editor
     often arrives without the ?q= handle list — so the grid comes back empty
     and stays empty, because init() already ran. Rebuild on every re-render.
     buildPage() bails out on its own if the server did render cards. */
  ['shopify:section:load', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(function () { learnHandles(); sync(); buildPage(); }, 80);
    });
  });

  // lazily-loaded tabs inject cards after load
  document.addEventListener('lazyincluded', function () { setTimeout(function () { learnHandles(); sync(); }, 60); }, true);
  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('lazyincluded', function () { setTimeout(sync, 60); });
  }

  window.vyWishSync = sync;   // callable by hand if anything else injects cards
})();
